// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main container */
.main.textos-legales {
    padding: 2rem;
    background-color: #f9fafb;
}

/* Headings */
.main.textos-legales h1 {
    font-size: 2rem;
    color: #1a365d;
    margin-bottom: 1.5rem;
}

.main.textos-legales h2 {
    font-size: 1.5rem;
    color: #2d3748;
    margin-top: 1.5rem;
    margin-bottom: 1rem;
}

/* Paragraphs and text */
.main.textos-legales p {
    font-size: 1rem;
    color: #4a5568;
    line-height: 1.6;
    margin-bottom: 1rem;
}

/* Lists */
.main.textos-legales ul {
    margin-bottom: 1rem;
}

.main.textos-legales ul li {
    margin-bottom: 0.5rem;
}

/* Links */
.main.textos-legales a {
    color: #3182ce;
    text-decoration: underline;
}

.main.textos-legales a:hover {
    color: #2c5282;
}

/* Responsive design */
@media (max-width: 768px) {
    .main.textos-legales {
        padding: 1rem;
    }

    .main.textos-legales h1 {
        font-size: 1.75rem;
    }

    .main.textos-legales h2 {
        font-size: 1.25rem;
    }
} `, "",{"version":3,"sources":["webpack://./src/pages/TextosLegales.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA,aAAa;AACb;IACI,eAAe;IACf,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA,wBAAwB;AACxB;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,UAAU;AACV;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA,UAAU;AACV;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA,sBAAsB;AACtB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":["/* Main container */\n.main.textos-legales {\n    padding: 2rem;\n    background-color: #f9fafb;\n}\n\n/* Headings */\n.main.textos-legales h1 {\n    font-size: 2rem;\n    color: #1a365d;\n    margin-bottom: 1.5rem;\n}\n\n.main.textos-legales h2 {\n    font-size: 1.5rem;\n    color: #2d3748;\n    margin-top: 1.5rem;\n    margin-bottom: 1rem;\n}\n\n/* Paragraphs and text */\n.main.textos-legales p {\n    font-size: 1rem;\n    color: #4a5568;\n    line-height: 1.6;\n    margin-bottom: 1rem;\n}\n\n/* Lists */\n.main.textos-legales ul {\n    margin-bottom: 1rem;\n}\n\n.main.textos-legales ul li {\n    margin-bottom: 0.5rem;\n}\n\n/* Links */\n.main.textos-legales a {\n    color: #3182ce;\n    text-decoration: underline;\n}\n\n.main.textos-legales a:hover {\n    color: #2c5282;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n    .main.textos-legales {\n        padding: 1rem;\n    }\n\n    .main.textos-legales h1 {\n        font-size: 1.75rem;\n    }\n\n    .main.textos-legales h2 {\n        font-size: 1.25rem;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
